import { parseJson } from 'legacy/lut/classes/helpers/JsonHelper'
import { IAction, TActionPopupSettings } from 'legacy/lut/classes/models/onboarding/IAction'

import { IForm } from 'core-components/classes/models/IForm'
import { DateHelper } from 'onboarding/utils/dateHelper'

export const mapActionsFromCrud = (data: IForm[]) => data.map(mapActionFromCrud)

export const mapActionFromCrud = (data: IForm): IAction => ({
  EntryId: data.EntryId || 0,
  Description: data.Description || '',
  Name: data.Name || '',
  PopupContent: data.PopupContent || null,
  PopupSettings: data.PopupSettings ? parseActionPopupSettings(data.PopupSettings) : null,
  Parent: data.Parent || null,
  Predecessor: data.Predecessor || 0,
  Process: data.Process || '',
  RequestId: data.RequestId || 0,
  Escalation: data.Escalation || 0,
  PrimaryRole: data.PrimaryRole || '',
  Status: data.Status,
  Estimate: data.Estimate || 0,
  WriteAudience: data.WriteAudience || '',
  TemplateWriteAudience: data.TemplateWriteAudience,
  CollectedData: data.CollectedData || '',
  WaitingForUUID: data.WaitingForUUID || '',
  UUID: data.UUID || '',
  ParentUUID: data.ParentUUID || '',
  SortOrder: data.SortOrder || 0,
  ProcessSortOrder: data.ProcessSortOrder || 0,
  StartDate: data.StartDate || '',
  EndDate: data.EndDate || '',
  PreparedDescription: data.PreparedDescription || '',
  SelectedPrimaryUser: data.SelectedPrimaryUser || '',
  SelectedBackupUser: data.SelectedBackupUser || '',
  Deep: data.Deep || 0,
  Inheritable: data.Inheritable || false,
  LinkToAnotherRequest: data.LinkToAnotherRequest || undefined,
  ModifiedBy: data.ModifiedBy || '',
  ExpirationDate: data.ExpirationDate,
  //backup users info
  PrimaryReserve: data.PrimaryReserve,
  OldPrimaryResponsibleUser: data.OldPrimaryResponsibleUser,
  ReservedPrimaryUserFrom: data.ReservedPrimaryUserFrom,
  ReservedPrimaryUserTo: data.ReservedPrimaryUserTo,
  BackupReserve: data.BackupReserve,
  OldBackupResponsibleUser: data.OldBackupResponsibleUser,
  ReservedBackupUserFrom: data.ReservedBackupUserFrom,
  ReservedBackupUserTo: data.ReservedBackupUserTo,
  TAT: data.TAT || 0,
  Modified: data.Modified || '',
  ExpirationHours: data.ExpirationHours,
  ExpirationSkippedSeconds: data.ExpirationSkippedSeconds,
  ExpiresAt: data.ExpiresAt ? DateHelper.convertServerISOToDate(data.ExpiresAt) : null,
})

export const parseActionPopupSettings = (value: string) => {
  const popup = parseJson<TActionPopupSettings>(value)
  if (popup && popup.showOnce !== undefined) {
    popup.showOnce.isViewed = Boolean(popup.showOnce.isViewed)
  }

  return popup
}
